import { config } from "../../../../cookist/com/lib/config/production.js";
import { CookistModuleLoader } from "../../../../cookist/com/pa/modularization/CookistModuleLoader.js";

const al = new CookistModuleLoader(window, config);
const gui = al.getGui();